import { Mark } from "@tiptap/core";

export const PersistentCommentMark = Mark.create({
  name: "persistentCommentMark",

  addAttributes() {
    return { id: { default: null }, commentId: { default: null } };
  },

  parseHTML() {
    return [{ tag: "span[data-persistent-comment-id]" }];
  },

  renderHTML({ HTMLAttributes }) {
    //
    return [
      "span",
      {
        ...HTMLAttributes,
        "data-persistent-comment-id": HTMLAttributes.commentId,
        class: "persistentComment",
        style: "background-color: var(--innovera-yellow100); cursor: pointer; transition: background-color 0.3s ease;"
      },
      0
    ];
  },

  addOptions() {
    return { ...this.parent?.(), spanning: true };
  },

  addMarkOptions() {
    return { ...this.parent?.(), spanning: true, inclusive: true };
  }
});
